import { Box, useTheme, Typography } from "@mui/material";
import { Helmet } from "react-helmet";
import React, { useState } from "react";
import GridContainer from "../../components/grid/GridContainer.jsx";
import GridItem from "../../components/grid/GridItem.jsx";
import { getLeranMoreStyle } from "../../components/customstyles/LearnMoreStyle.jsx";
import BodyAreaOne from "../../assets/images/LearnMore/BodyAreaOne.png";
import BodyAreaTwo from "../../assets/images/LearnMore/BodyAreaTwo.png";
import BodyAreaThree from "../../assets/images/LearnMore/BodyAreaThree.png";
import BodyAreaFour from "../../assets/images/LearnMore/BodyAreaFour.png";
import Breadcrumbs from "./Breadcrumbs.jsx";

const useStyles = () => {
  let theme = useTheme();
  return getLeranMoreStyle(theme);
};

function BodyAreas() {
  const styles = useStyles();
  const [loadingStarted, setLoading] = useState(true);

  const handleBodyAreaLoading = () => {
    setLoading(false);
  };
  return (
    <Box sx={styles.learnMorePageStyle}>
      <Helmet>
        <title>Patients</title>
      </Helmet>
      <Breadcrumbs handleLoading={handleBodyAreaLoading} name={"Body Areas"} />
      {!loadingStarted && (
        <div className="FSUnmask">
          <GridContainer>
            <GridItem
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ marginTop: "30px" }}
            >
              <Box>
                <Typography sx={styles.learnMoreHeading}>Body Areas</Typography>
              </Box>
              <Box sx={{ marginTop: "30px" }}>
                <Typography sx={styles.bodyAreasText}>
                  The AIMS ratings are detailed according to body area to help
                  you ensure that observations are methodical and cover the
                  entire patient. The first 7 items are rated on a 0-to-4 scale.
                </Typography>
              </Box>
              <Box sx={{ marginTop: "20px" }}>
                <img
                  src={BodyAreaOne}
                  alt="BodyAreaOne"
                  width="100%"
                  height="193px"
                />
              </Box>
              <Box sx={{ marginTop: "15px" }}>
                <img
                  src={BodyAreaTwo}
                  alt="BodyAreaTwo"
                  width="100%"
                  height="229px"
                />
              </Box>
              <Box sx={{ marginTop: "15px" }}>
                <Typography sx={styles.bodyAreasHeading}>
                  Click the “What’s this?” link
                </Typography>
              </Box>
              <Box sx={{ marginTop: "20px" }}>
                <img
                  src={BodyAreaThree}
                  alt="BodyAreaThree"
                  width="100%"
                  height="73px"
                />
              </Box>
              <Box sx={{ marginTop: "10px" }}>
                <img
                  src={BodyAreaFour}
                  alt="BodyAreaFour"
                  width="100%"
                  height="250px"
                />
              </Box>
            </GridItem>
          </GridContainer>
        </div>
      )}
    </Box>
  );
}

export default BodyAreas;
